import React from 'react';
import { MapPin, StickyNote } from 'lucide-react';

/** client#7/#8: where the shift is and the shift notes, for staff-facing shift pages.
 *  `shift.address` is sent only to the worker on the shift (GET /roster/shifts/{id}, /roster/my-shifts). */
export function ShiftAddress({ shift, compact = false }) {
  const address = (shift?.address || '').trim();
  if (!address) return null;
  const label = shift.address_source === 'HOUSE' && shift.house_name ? shift.house_name : null;
  const maps = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  return (
    <div className={`flex items-start gap-2 min-w-0 ${compact ? 'text-xs' : 'text-sm'}`} data-testid="shift-address">
      <MapPin className={`${compact ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-muted-foreground mt-0.5 flex-shrink-0`} />
      <div className="min-w-0">
        {label && !compact && <p className="font-medium">{label}</p>}
        <a href={maps} target="_blank" rel="noopener noreferrer" className={`text-primary hover:underline ${compact ? 'truncate block' : ''}`}
          onClick={(e) => e.stopPropagation()} title={address}>
          {address}
        </a>
      </div>
    </div>
  );
}

export function ShiftNotes({ notes, compact = false }) {
  const text = (notes || '').trim();
  if (!text) return compact ? null : (
    <p className="text-sm text-muted-foreground italic" data-testid="shift-notes-empty">No shift notes</p>
  );
  return (
    <div className={`flex items-start gap-2 min-w-0 ${compact ? 'text-xs' : 'text-sm'}`} data-testid="shift-notes">
      <StickyNote className={`${compact ? 'h-3.5 w-3.5' : 'h-4 w-4'} text-amber-600 mt-0.5 flex-shrink-0`} />
      <p className={`${compact ? 'line-clamp-2' : 'whitespace-pre-wrap'} text-foreground`} title={compact ? text : undefined}>{text}</p>
    </div>
  );
}

/** Participant names for a shift — every resident on SIL / shared shifts, not just the primary. */
export function shiftParticipantNames(shift) {
  const linked = (shift?.linked_participant_details || []).map(p => p.name).filter(Boolean);
  return linked.length ? linked.join(', ') : (shift?.participant_name || '');
}
